export function computePanQuantity(
  dozens: number | null | undefined,
  buns: number | null | undefined
): number {
  if (dozens == null && buns == null) return 48;
  return (dozens ?? 0) * 12 + (buns ?? 0);
}

export function formatPanQuantityDisplay(totalPieces: number): string {
  const dz = Math.floor(totalPieces / 12);
  const rem = totalPieces % 12;
  return rem === 0 ? `${dz} dozens` : `${dz} doz ${rem}`;
}
